// extracted by mini-css-extract-plugin
export default {"libraryLiveLabel":"VjgVOIY9kCMMoUSWTPUQ","libraryAlertContainer":"r1ATt4dfUr4UQ7qatQMj"};